module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport@3x-8f5e25d5378b7edbd333cd348e419f73.webp";